import React, { useMemo, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import LineArt from '@/assets/images/lineArt.png';
import OnboardingCandidatesPanel from '@/components/organisms/onboarding-management/OnboardingCandidatesPanel';
import useOnboardingCandidates from '@/services/admin-services/query/useOnboardingCandidates';
import useOnboardingStepCounts from '@/services/admin-services/query/useOnboardingStepCounts';

const ManagementOnboarding = () => {
    const navigate = useNavigate();

    const [searchString, setSearchString] = useState('');
    const [sortOrder, setSortOrder] = useState('CREATED_DESC');
    const [sliceNumber, setSliceNumber] = useState(1);
    const [stepFilter, setStepFilter] = useState(null);

    const normalizedSearchString = searchString.trim();
    const searchFilter = normalizedSearchString.length >= 2 ? normalizedSearchString : undefined;

    const {
        data: candidatesData,
        loading: candidatesLoading,
        error: candidatesError,
    } = useOnboardingCandidates(sliceNumber, searchFilter, sortOrder, stepFilter);

    const candidates = useMemo(() => candidatesData?.candidates || [], [candidatesData?.candidates]);
    const hasNextCandidates = Boolean(candidatesData?.hasNext);

    const {
        data: stepCounts,
        loading: stepCountsLoading,
        error: stepCountsError,
        refetch: refetchStepCounts,
    } = useOnboardingStepCounts();

    const handleStepFilterChange = (step) => {
        setStepFilter(step);
        setSliceNumber(1);
        void refetchStepCounts();
    };

    return (
        <div className="h-full min-h-0 flex flex-col gap-secondDegree ">

            <div className="min-h-0 flex-1 relative">

                <OnboardingCandidatesPanel
                    candidates={candidates}
                    loading={candidatesLoading}
                    error={candidatesError}
                    selectedCandidateUuid={null}
                    searchString={searchString}
                    sortOrder={sortOrder}
                    currentPage={sliceNumber}
                    hasNextPage={hasNextCandidates}
                    autoSelectFirstCandidate={false}
                    stepFilter={stepFilter}
                    stepFilterMode="single"
                    stepCounts={stepCounts}
                    stepCountsLoading={stepCountsLoading}
                    stepCountsError={stepCountsError}
                    onSearchChange={setSearchString}
                    onSortOrderChange={setSortOrder}
                    onStepFilterChange={handleStepFilterChange}
                    onSelectCandidate={(uuid) => {
                        navigate(`/management/onboarding/${uuid}`);
                    }}
                    onPreviousPage={() => setSliceNumber((previous) => Math.max(1, previous - 1))}
                    onNextPage={() => setSliceNumber((previous) => previous + 1)}
                />
            </div>
        </div>
    );
};

export default ManagementOnboarding;
